import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class MultiFileTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private modules: string[],
    private prefix = '/i18n'
  ) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    const requests = this.modules.map(moduleName =>
      this.http
        .get<Record<string, string>>(`${this.prefix}/${lang}/${moduleName}.json`)
        .pipe(catchError(() => of({})))
    );

    return forkJoin(requests).pipe(
      map(results => results.reduce((acc, curr) => ({ ...acc, ...curr }), {}))
    );
  }
}
